'use strict';

var directives = angular.module('flatify.directives', []);

// Converted from Coffeescript
directives.directive('customBackground', function() {
    return {
      restrict: "A",
      controller: [
        '$scope', '$element', '$location', function($scope, $element, $location) {
          var addBg, path;
          path = function() {
            return $location.path();
          };
          addBg = function(path) {
            $element.removeClass('body-home body-special body-tasks body-lock');
            switch (path) {
              case '/':
                $element.addClass('body-home');
                break;
              case '/404':
              case '/pages/500':
              case '/pages/signin':
              case '/pages/forgot':
              case '/pages/signup':
                $element.addClass('body-special');
                break;
              case '/pages/lock-screen':
                $element.addClass('body-special body-lock');
                break;
              case '/tasks':
                $element.addClass('body-tasks');
            }
            if (path.indexOf('/pages/') === 0) {
              return $element.addClass('body-special');
            }
          };
          addBg($location.path());
          return $scope.$watch(path, function(newVal, oldVal) {
            if (newVal === oldVal) {
              return;
            }
            return addBg($location.path());
          });
        }
      ]
    };
  });

directives.directive('uiColorSwitch', [function() {
    return {
        restrict: 'A',
        link: function(scope, ele) {
          return ele.find('.color-option').on('click', function(event) {
            var $this, hrefUrl, style;
            $this = $(this);
            hrefUrl = void 0;
            style = $this.data('style');
            if (style === 'loulou') {
              hrefUrl = 'styles/main.css';
              $('link[href^="styles/main"]').attr('href', hrefUrl);
            } else if (style) {
              style = '-' + style;
              hrefUrl = 'styles/main' + style + '.css';
              $('link[href^="styles/main"]').attr('href', hrefUrl);
            } else {
              return false;
            }
            return event.preventDefault();
          });
        }
      };
}]);

directives.directive('toggleMinNav', ['$rootScope', function($rootScope) {
    return {
        restrict: 'A',
        link: function(scope, ele) {
          var $window, Timer, app, updateClass;
          app = $('#app');
          $window = $(window);
          ele.on('click', function(e) {
            if (app.hasClass('nav-min')) {
              app.removeClass('nav-min');
              $('#nav-logo').removeClass('hidden');
              $rootScope.$broadcast('minNav:disabled');
            } else {
              app.addClass('nav-min');
              $('#nav-logo').addClass('hidden');
              $rootScope.$broadcast('minNav:enabled');
            }
            return e.preventDefault();
          });
          Timer = void 0;
          updateClass = function() {
            var width;
            width = $window.width();
            if (width < 768) {
              return app.removeClass('nav-min');
            }
          };
          return $window.resize(function() {
            var t;
            clearTimeout(t);
            t = setTimeout(updateClass, 300);
            return t;
          });
        }
      };
}]);

directives.directive('collapseNav', ['$timeout', function($timeout) {
    return {
        restrict: 'A',
        link: function(scope, ele) {
          $timeout(function() {
            var $a, $aRest, $lists, $listsRest, app;
            $lists = ele.find('ul').parent('li');
            $lists.append('<i class="fa fa-caret-right icon-has-ul"></i>');
            $a = $lists.children('a');
            $listsRest = ele.children('li').not($lists);
            $aRest = $listsRest.children('a');
            app = $('#app');
            $a.on('click', function(event) {
              var $parent, $this;
              if (app.hasClass('nav-min')) {
                return false;
              }
              $this = $(this);
              $parent = $this.parent('li');
              $lists.not($parent).removeClass('open').find('ul').slideUp();
              $parent.toggleClass('open').find('ul').slideToggle();
              return event.preventDefault();
            });
            $aRest.on('click', function() {
              return $lists.removeClass('open').find('ul').slideUp();
            });
            return scope.$on('minNav:enabled', function() {
              return $lists.removeClass('open').find('ul').slideUp();
            });
          }, 0);
        }
      };
}]);

directives.directive('highlightActive', [function() {
    return {
        restrict: "A",
        controller: [
          '$scope', '$element', '$attrs', '$location', function($scope, $element, $attrs, $location) {
            var highlightActive, links, path;
            links = $element.find('a');
            path = function() {
              return $location.path();
            };
            highlightActive = function(links, path) {
              path = '#' + path;
              return angular.forEach(links, function(link) {
                var $li, $link, href;
                $link = angular.element(link);
                $li = $link.parent('li');
                href = $link.attr('href');
                if ($li.hasClass('active')) {
                  $li.removeClass('active');
                }
                if (href && path.indexOf(href) === 0) {
                  return $li.addClass('active');
                }
              });
            };
            highlightActive(links, $location.path());
            return $scope.$watch(path, function(newVal, oldVal) {
              if (newVal === oldVal) {
                return;
              }
              return highlightActive(links, $location.path());
            });
          }
        ]
      };
}]);

directives.directive('toggleOffCanvas', [function() {
      return {
        restrict: 'A',
        link: function(scope, ele) {
          return ele.on('click', function() {
              if (scope.$root.isSmallScreen()) {
                  return $('#app').toggleClass('on-canvas');
              }
          });
        }
      };
}]);

directives.directive('slimScroll', [function() {
    return {
        restrict: 'A',
        link: function(scope, ele) {
          return ele.slimScroll({
            height: '100%'
          });
        }
      };
}]);

directives.directive('goBack', [function() {
    return {
        restrict: "A",
        controller: [
          '$scope', '$element', '$window', function($scope, $element, $window) {
            return $element.on('click', function() {
              return $window.history.back();
            });
          }
        ]
      };
}]);
